let itemData = [
    [
        {
            chapter : 1,
            page : '1',
            subject : '클래식 서버 플레이 경험은 어느 정도인가요?',
            answerType : 'radio',
            wrap : 'span',
            width : '180',
            answer : [
                '1개월 이내',
                '3개월 이내',
                '6개월 이내',
                '1년 이상',
                '1년 6개월 이상',
            ]
        },
        {
            chapter : 1,
            page : 1,
            subject : '라이브 서버 플레이 경험이 있으신가요?',
            answerType : 'radio',
            wrap : 'span',
            width : '190',
            answer : [
                '있다',
                '없다',
            ]
        },
        {
            chapter : 1,
            page : 1,
            subject : '현재 플레이하고 있는 클래스는 무엇인가요?',
            answerType : 'radio',
            wrap : 'span',
            width : '190',
            answer : [
                '검성',
                '수호성',
                '살성',
                '궁성',
                '마도성',
                '정령성',
                '치유성',
                '호법성',
            ]
        },
        {
            chapter : 1,
            page : 1,
            subject : '하루 플레이 타임은 얼마나 되나요?',
            answerType : 'radio',
            wrap : 'span',
            width : '190',
            answer : [
                '1시간 이내',
                '2시간 이내',
                '3시간 이내',
                '4시간 이상',
            ]
        },
        {
            chapter : 1,
            page : 1,
            subject : '클래식 서버 플레이 경험에 대한 만족도는 어느 정도인가요?',
            answerType : 'radio',
            wrap : 'span',
            width : '180',
            answer : [
                '매우 만족',
                '만족',
                '보통',
                '불만족',
                '매우 불만족',
            ]
        },
    ],//탭1
    [
        {
            chapter : 2,
            page : 2,
            answerType : 'radio',
            wrap : 'div',
            width : '320',
            subject : `2020년 11월 11일 클래식 오픈부터 현재 2.4 업데이트까지 총 7번의 메인 업데이트가 진행되었습니다.<br><i></i>
                        지금까지의 클래식 업데이트 중 가장 만족스러운 업데이트는 무엇인가요?`,
            answer : [
                '1.1 데바, 클래식을 연주하다',
                '1.5 데바, 타하바타를 만나다',
                '1.7 데바, 보물의 주인이 되다',
                '1.9 데바, 전장을 지배하다',
                '2.0 데바, 용계를 깨우다',
                '2.2 데바, 아라카를 열다',
                '2.4 데바, 도전의 길을 걷다',
            ]
        },
        {
            chapter : 2,
            page : 2,
            answerType : 'radio',
            wrap : 'div',
            width : '620',
            subject : `선택한 업데이트가 가장 만족스러웠던 이유는 무엇인가요?`,
            answer : [
                '풍성하고 다양한 할 거리 ',
                '새로운 도전이 가능한 인던 업데이트',
                'PVP 관련 전장 업데이트',
                '새로운 어비스 장비 라인업 추가',
                '과거 클래식 서버에는 없던 새로운 콘텐츠 추가',
                '새로운 필드 추가',
                `기타<input id="text_2_2_7" type="text" maxlength="100">`,
            ]
        },
    ],//탭2
    [
        {
            chapter : 2,
            page : 3,
            answerType : 'radio',
            wrap : 'span',
            width : '180',
            subject : `클래식 서버 업데이트는 짧게는 몇 주, 길게는 약 몇 달 정도의 주기로 크고 작은 업데이트가 되었습니다.<br><i></i>
                        업데이트가 진행되는 주기가 적정하다고 생각하나요?`,
            answer : [
                '매우 만족',
                '만족',
                '보통',
                '불만족',
                '매우 불만족',
            ]
        },
        {
            chapter : 2,
            page : 3,
            answerType : 'radio',
            wrap : 'div',
            width : '620',
            subject : `어떤 주기로 업데이트가 진행되는 것이 좋다고 생각하는지?`,
            answer : [
                '현재 기준 만족한다',
                '2주에 1번 이상',
                '1달에 1번 이상 ',
                '2달에 1번 이상',
                '3달에 1번 이상',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : 4,
            answerType : 'radio',
            wrap : 'span',
            width : '180',
            subject : `클래식만의 신규 콘텐츠 ‘티아크 연구기지‘ 는 2021년 8월 25일 업데이트되었습니다.<br><i></i>
                        라이브 서버에는 없는 클래식만의 오리지널 콘텐츠 첫 출시 시점이 적절했다고 생각하시나요?   `,
            answer : [
                '매우 만족',
                '만족',
                '보통',
                '불만족',
                '매우 불만족',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : 5,
            answerType : 'radio',
            wrap : 'span',
            width : '190',
            subject : `티아크 연구기지 플레이 경험이 있으신가요?`,
            answer : [
                '있다',
                '없다',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : '5-1',
            answerType : 'radio',
            wrap : 'span',
            width : '180',
            subject : `티아크 연구기지 플레이 경험은 어떠셨나요?`,
            answer : [
                '매우 만족',
                '만족',
                '보통',
                '불만족',
                '매우 불만족',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : '5-2',
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `티아크 연구기지가 어떤 부분에서 만족스러우셨나요?`,
            answer : [
                '클래식만의 새로운 업데이트 콘텐츠',
                '전장 콘텐츠 추가',
                '티아크 연구기지만의 게임 룰',
                '신규 장신구 장비 추가',
                'AP 및 훈장 획득처 추가',
                '기타<input id="text_5-2_1_6" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : '5-2',
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `티아크 연구기지가 어떤 부분에서 만족스럽지 못하셨나요?`,
            answer : [
                '티아크 연구기지만의 게임 룰',
                '노력 대비 적은 보상 아이템',
                '오래 걸리는 매칭 시간',
                '콘텐츠 추가에 대한 플레이 부담',
                '전장 콘텐츠에 관심이 적음',
                '기타<input id="text_5-2_1_6" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : 6,
            answerType : 'radio',
            wrap : 'span',
            width : '190',
            subject : `2022년 5월 18일 한층 더 높아진 난이도의 ‘해방된 파슈만디르 사원’ 이 업데이트되었습니다.<br><i></i>
                        해방된 파슈만디르 사원 플레이 경험이 있으신가요?`,
            answer : [
                '있다',
                '없다',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : '6-1',
            answerType : 'radio',
            wrap : 'span',
            width : '180',
            subject : `해방된 파슈만디르 사원의 플레이 경험은 어떠셨나요?`,
            answer : [
                '매우 만족',
                '만족',
                '보통',
                '불만족',
                '매우 불만족',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : '6-2',
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `해방된 파슈만디르 사원이 어떤 부분에서 만족스러우셨나요?`,
            answer : [
                '신규 인던 콘텐츠 추가',
                '마지막 보스만 공략 가능한 루트',
                '높은 능력치의 장비 추가',
                '도전 가능한 높은 난이도',
                '기타<input id="text_6-2_1_5" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : '6-2',
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `해방된 파슈만디르 사원이 어떤 부분에서 만족스럽지 못하셨나요?`,
            answer : [
                '난이도가 높은 공략',
                '노력 대비 적은 보상 아이템',
                '콘텐츠 추가에 대한 플레이 부담',
                '인던 콘텐츠에 관심이 적음',
                '기타<input id="text_6-2_1_5" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : 7,
            answerType : 'checkbox',
            wrap : 'div',
            width : '600',
            subject : `업데이트 진행 시마다 좀 더 재미있고 안정적으로 업데이트를 경험하실 수 있도록 하기 위한 환경을 고민하고 있습니다.<br><i></i>
                        앞으로 대규모 업데이트 진행 시 함께 병행되었으면 하는 활동이 있다면 무엇인가요? (최대 2개 선택)`,
            answer : [
                '신 서버 오픈 ',
                '친구 초대 이벤트 ',
                '종족 생성 제한 해제 ',
                '서버 이전 조건 완화 ',
                '서버 통합 ',
                '기타<input id="text_7_1_6" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : 8,
            answerType : 'radio',
            wrap : 'span',
            width : '180',
            subject : `그동안 총 19편의 클래식 개발자 노트를 통해서 업데이트 관련 여러 가지 소식을 전해 드렸습니다.<br><i></i>
                        클래식 서버 업데이트 진행 시 개발자 노트를 통한 사전 안내 및 설명이 유익하였나요?`,
            answer : [
                '매우 만족',
                '만족',
                '보통',
                '불만족',
                '매우 불만족',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : 9,
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `개발자 노트는 대부분 업데이트에 관련된 주제에 대해 안내를 드렸었는데요.<br><i></i>
                        개발자 노트를 통해 안내되는 내용 중 어떤 부분이 가장 유익하였나요?`,
            answer : [
                '업데이트 일정 사전 안내 ',
                '업데이트가 진행되는 배경이나 기획 의도 설명 ',
                '새롭게 추가되는 스토리 사전 공개 ',
                '앞으로 진행되는 업데이트에 대한 사전 예고 ',
                '고객들과 소통하고 있다는 느낌',
            ]
        },
    ],
    [
        {
            chapter : 2,
            page : 10,
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `개발자 노트는 업데이트에 많은 비중을 두고 안내를 하다 보니 다양한 주제를 다루긴 어려운 부분이 있었습니다.<br><i></i>
                        부족한 부분이 있다면 어떤 부분이 좀 더 보강되길 원하시나요?`,
            answer : [
                '업데이트 일정 사전 안내 ',
                '업데이트가 진행되는 배경이나 기획 의도 설명 ',
                '새롭게 추가되는 스토리 사전 공개 ',
                '앞으로 진행되는 업데이트에 대한 사전 예고 ',
                '고객들과 소통하고 있다는 느낌',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 11,
            answerType : 'checkbox',
            wrap : 'span',
            width : '300',
            subject : `스킬 관련된 콘텐츠의 개선이 진행될 경우 어떤 것이 가장 먼저 진행되는 것이 좋을까요? (최대 2개 선택)`,
            answer : [
                '종족별 다르게 적용된 스킬',
                '신규 스킬 추가',
                '스킬 대미지 관련 밸런스',
                '스티그마 스킬 트리 개선',
                '스킬 개수 조정',
                '기타<input id="text_11_1_6" type="text" maxlength="100" style="width: 190px;">',
            ]
        },
        {
            chapter : 3,
            page : 11,
            answerType : 'radio',
            wrap : 'span',
            width : '450',
            subject : `직업 스킬 중 밸런스를 조정한다면 어떤 종류를 가장 먼저 개선하는 것이 좋을까요?`,
            answer : [
                '공격형 대미지 스킬',
                '방어형 스킬',
                '직업 능력치를 향상시켜주는 버프 스킬',
                '상대를 제압하는 디버프 스킬',
                '기타<input id="text_11_2_5" type="text" maxlength="100" style="width: 250px;">',
            ]
        },
        {
            chapter : 3,
            page : 11,
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `각 직업별 상성 되는 직업 혹은 스킬이 있는 것이 좋을까요?`,
            answer : [
                'PVP 재미를 위해 상성 직업은 필요하다',
                '오히려 PVP의 재미를 반감 시킬 수 있기 때문에 필요 없다',
            ]
        },
    ],//탭 3
    [
        {
            chapter : 3,
            page : 12,
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `잉기스온과 겔크마로스 필드 활용도에 있어 어떤 부분이 가장 부족하다고 생각되나요?`,
            answer : [
                '전체 필드 곳곳을 다 사용하지 않음 (일부 지역만 이용함)',
                'PVP를 진행할 때 플레이 동선의 어려움',
                '상대 종족 필드로 이동 시 불편함',
                '필드에서 플레이를 오래 할 수 있도록 하는 콘텐츠 부족',
                '기타<input id="text_12_1_5" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 13,
            answerType : 'checkbox',
            wrap : 'div',
            width : '600',
            subject : `경쟁 관련 콘텐츠 중 개선이나 추가가 되었으면 하는 콘텐츠가 있다면 무엇인가요? (최대 2개 선택)`,
            answer : [
                'PVE 랭킹 시스템 도입 ',
                'PVP 관련 새로운 랭킹 시스템 도입 ',
                '어비스 포인트 계급 순위 시스템 개편 ',
                '상위 랭커들의 보상적인 매리트 ',
                '상위 랭커들에게 명예감을 보여줄 수 있는 외형적인 변화 ',
                '파티 혹은 레기온 단위 전장 랭킹 시스템 ',
                '기타<input id="text_13_1_7" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 14,
            answerType : 'checkbox',
            wrap : 'span',
            width : '190',
            subject : `향후 업데이트부터 가장 먼저 추가되길 바라는 신규 콘텐츠는 무엇인가요? (최대 2개 선택)`,
            answer : [
                '필드',
                '인던',
                '전장',
                '스킬',
                '시스템 개편',
                '신규 장비',
            ]
        },
        {
            chapter : 3,
            page : 14,
            answerType : 'radio',
            wrap : 'span',
            width : '330',
            subject : `아이온 과거 인던 중 가장 먼저 등장했으면 하는 인던이 있다면 어디인가요?`,
            answer : [
                '타메스',
                '라디스 숲/도르겔 저택',
                '렌투스 기지',
                '용제의 안식처',
                '아투람 공중요새',
                '기타<input id="text_14_2_6" type="text" maxlength="100" style="width: 150px">',
            ]
        },
        {
            chapter : 3,
            page : 14,
            answerType : 'radio',
            wrap : 'div',
            width : '500',
            subject : `아이온 과거 인던이 출시될 경우 그대로 업데이트되길 희망하시나요?`,
            answer : [
                '과거 플레이 룰과 난이도 그대로 업데이트되길 희망',
                '과거와 다르게 업그레이드되어 업데이트되길 희망',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 15,
            answerType : 'radio',
            wrap : 'span',
            width : '250',
            subject : `아이온 과거 필드 중 가장 먼저 등장했으면 하는 필드가 있다면 어디인가요?`,
            answer : [
                '사르판',
                '티아마란타',
                '티아마란타의 눈',
                '카탈람',
                '칼도르',
                '기타<input id="text_15_1_6" type="text" maxlength="100" style="width: 140px">',
            ]
        },
        {
            chapter : 3,
            page : 15,
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `선택한 필드를 가장 선호하게 된 이유는 무엇인가요?`,
            answer : [
                '다양한 규모의 PVP를 할 수 있어서',
                '이동 수단이 좋고 최적화가 잘 되어서',
                '필드 내 공략할 콘텐츠가 많아서',
                '필드 외형이 취향이라서',
                '기타<input id="text_15_2_5" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 16,
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `클래식 서버에 신규 직업이 업데이트가 된다면 어떻게 추가되면 좋을까요?`,
            answer : [
                '클래식만의 신규 직업',
                '사격',
                '기갑',
                '음유',
                '채화',
                '기타<input id="text_16_1_6" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 17,
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `앞으로 클래식 서버에서 레벨 확장이 필요하다고 생각하시나요?`,
            answer : [
                '55레벨 유지',
                '55레벨 이후 확장',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : '17-1',
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `레벨 확장이 되지 않을 경우 클래스 성장은 어떤 식으로 진행되길 희망하시나요?`,
            answer : [
                '기존 60레벨 이후 직업 스킬들 추가 ',
                '55레벨 스킬을 유지하고 지속적으로 밸런스 조정',
                '클래식만의 신규 직업 스킬 추가',
                '장비 능력치 증가로 성장감 적용',
                '기타<input id="text_17-1_1_5" type="text" maxlength="100">',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : '17-1',
            answerType : 'radio',
            wrap : 'div',
            width : '600',
            subject : `레벨 확장이 된다면 몇 레벨까지 확장되는 것이 좋을까요?`,
            answer : [
                '60레벨',
                '65레벨',
                '70레벨',
                '75레벨',
                '80레벨 이상',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 18,
            answerType : 'checkbox',
            wrap : 'span',
            width : '300',
            subject : `아이온 과거 시스템 중 클래식 서버에도 빠르게 적용되었으면 하는 시스템이 있다면 무엇일까요? (최대 2개 선택)`,
            answer : [
                '탑승물',
                '하우징',
                '도우미 시스템',
                '옵션 재부여 시스템',
                '제작 달인/명인 포기 시스템',
                '기타<input id="text_18_1_6" type="text" maxlength="100" style="width: 180px">',
            ]
        },
        {
            chapter : 3,
            page : 18,
            answerType : 'radio',
            wrap : 'span',
            width : '250',
            subject : `전 서버로 이용 가능한 시스템이 있다면 가장 먼저 반영되면 좋겠다고 생각하는 것은 무엇인가요?`,
            answer : [
                '아이템 거래',
                '채팅 이용',
                '이벤트 참여',
                '레기온 구성',
                '친구 등록',
                '저레벨 전용 플레이 서버',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 19,
            answerType : 'radio',
            wrap : 'span',
            width : '400',
            subject : `현재 큐브 확장 과정에서 가장 불편한 것은 무엇인가요?`,
            answer : [
                '확장 키나 가격이 비싸다',
                '큐브 확장 퀘스트의 난이도가 높다',
                '확장할 수 있는 방법을 인지하기 어렵다',
                '지금 정도도 적당하다',
                '기타<input id="text_19_1_5" type="text" maxlength="100" style="width: 260px">',
            ]
        },
        {
            chapter : 3,
            page : 19,
            answerType : 'radio',
            wrap : 'span',
            width : '250',
            subject : `큐브 확장에 대한 개선이 될 경우 어떤 방향으로 변화가 있는 것이 좋을까요?`,
            answer : [
                '키나를 사용해서 확장',
                '큐나를 사용해서 확장',
                '퀘스트를 통해 확장',
            ]
        },
        // {
        //     chapter : 3,
        //     page : 19,
        //     answerType : 'checkbox',
        //     wrap : 'span',
        //     width : '250',
        //     subject : `큐브 확장은 어떤 식으로 적용되는 것이 좋을까요? (최대 2개 선택)`,
        //     answer : [
        //         '인벤토리 큐브 줄 증가',
        //         '펫 창고 수 추가',
        //         '개인 창고 줄 추가',
        //         '계정 창고 줄 추가',
        //         '그 외 별도 창고 추가',
        //     ]
        // },
    ],
    [
        {
            chapter : 3,
            page : 20,
            answerType : 'checkbox',
            wrap : 'div',
            width : '600',
            subject : `우편 시스템에서 불편하다고 생각하는 것은 무엇인가요? (최대 2개 선택)`,
            answer : [
                '우편 공간 부족',
                '우편 물품을 한 개씩 수령 가능',
                '특급 우편 NPC 재소환 시간',
                '우편에 아이템을 여러 개 첨부하지 못하는 것',
            ]
        },
    ],
    [
        {
            chapter : 3,
            page : 21,
            answerType : 'radio',
            wrap : 'span',
            width : '400',
            subject : `지금 아이온 클래식 운영 서비스 중 가장 먼저 개선되었으면 하는 영역은 무엇인가요?`,
            answer : [
                '서버별 인원 불균형',
                '서버 내 종족 불균형',
                '불량 이용자 조치',
                '업데이트 커뮤니케이션',
                '이벤트 진행',
            ]
        },
        {
            chapter : 3,
            page : 21,
            answerType : 'text',
            wrap : 'span',
            width : '600',
            subject : `해당 항목을 선택하신 이유는 무엇인가요?`,
            answer : [
                '<input id="text9_1" type="text" maxlength="100" style="width: 800px">',
            ]
        },
    ],
];

export default itemData;